<template>
    <section id="training" class="page">
        <header class="main fixed">
            <h1><img class="button" src="img/arrow_left.svg" width="20" alt="" @click="$router.go(-1)" />{{ header }}</h1>
        </header>

        <div class="content to-bottom">
            <div class="scroll with-padding">
                <h2>Krok {{ $route.params.step_number }}</h2>
                <h3>{{ step_header }}</h3>
                <div v-html="step_content"></div>
                <span class="btn btn-primary" @click="goToNextStep" v-if="has_next_step">Następny krok</span>
                <span class="btn btn-primary" @click="$router.push({ name: 'congrats' })" v-if="! has_next_step">Koniec</span>
            </div>
        </div>

        <footer class="main">
            <p class="partner">Partner aplikacji: <img src="img/logo_isla.png" width="100" alt="" /></p>
        </footer>

        <Drink v-if="drink" />
    </section>
</template>

<script>
import Drink from './Drink';
import touch from '../mixins/touch'
import resize from '../mixins/resize'
import store from '../store'
import steps from '../store/steps'

export default {
    name: 'Step',
    components: {
        Drink
    },
    data() {
        return {
            drink: false,
            can_play_audio: true,
            has_next_step: true,
            header: '',
            step_header: '',
            step_content: ''
        }
    },
    mixins: [touch, resize],
    created: function() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            let step_data = steps.trainings[this.$route.params.training_type]['steps'][this.$route.params.step_number];

            this.header = steps.trainings[this.$route.params.training_type]['header'],
            this.step_header = step_data.header;
            this.step_content = step_data.content;
            this.drink = step_data.drink;

            if (steps.trainings[this.$route.params.training_type]['steps'][parseInt(this.$route.params.step_number) + 1] === undefined) {
                this.has_next_step = false;
            }

            this.initEvents();
        },
        initEvents() {
            let that = this;

            this.$nextTick(function() {
                let audios = document.getElementsByClassName('audio');

                if (audios.length) {
                    Array.prototype.forEach.call(audios, function(el) {
                        el.addEventListener('click', function(ev) {
                            ev.preventDefault();

                            if (that.can_play_audio !== true) {
                                return;
                            }

                            let audio = new Audio(this.href);
                            that.can_play_audio = false;
                            audio.play();

                            audio.addEventListener('ended', function() {
                                that.can_play_audio = true;
                            })
                        });
                    });
                }
            });
        },
        goToNextStep() {
            this.$router.push({ name: 'training', params: { training_type: this.$route.params.training_type, step_number: parseInt(this.$route.params.step_number) + 1 }})
        }
    }
}
</script>
